/**
 * App Entry File
 * Vuely: A Powerfull Material Design Admin Template
 * Copyright 2018. All Rights Reserved
 * Created By: The Iron Network, LLC
 * Made with Love
 */
import 'babel-polyfill';
import Vue from 'vue'
import Vuetify from 'vuetify'
// import * as VueGoogleMaps from 'vue2-google-maps'
// import { Vue2Dragula } from 'vue2-dragula'
import VueQuillEditor from 'vue-quill-editor'
import wysiwyg from 'vue-wysiwyg'
import VueBreadcrumbs from 'vue2-breadcrumbs'
import VueResource from 'vue-resource'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
// import AmAngularGauge from 'amcharts3/amcharts/gauge'
// import Nprogress from 'nprogress'
import VueI18n from 'vue-i18n'
import VueTour from 'vue-tour'
import fullscreen from 'vue-fullscreen'
// import InstantSearch from 'vue-instantsearch'
// import VueVideoPlayer from 'vue-video-player';
// import Croppa from 'vue-croppa';
import ConfigLoader from './helpers/config-loader'
// global components
import GlobalComponents from './globalComponents'
import auth from './auth'
import config from './config'
import { formatCurrency } from '@/helpers/formatter'

// app.vue
import App from './App'
// import primaryTheme from "Themes/primaryTheme";

// websocket
import SocketIO from 'socket.io-client';
import VueSocketIO from 'vue-socket.io'
// router
import router from './router'

// themes
import primaryTheme from './themes/primaryTheme';

// store
import store from './store/store'

// include script file
import './lib/VuelyScript'

// include all css files
import './lib/VuelyCss'

// messages
import messages from './lang';

// load config
const c = ConfigLoader.get({ config }) 


Vue.use(ConfigLoader, {
	config
})

// navigation guards before each

// navigation guard after each
router.afterEach((to, from) => {
	setTimeout(() => {
		const contentWrapper = document.querySelector(".v-content__wrap");
		if(contentWrapper !== null){
			contentWrapper.scrollTop = 0;
		}
		const boxedLayout = document.querySelector('.app-boxed-layout .app-content');
		if(boxedLayout !==  null){
			boxedLayout.scrollTop = 0;
		}
		const miniLayout = document.querySelector('.app-mini-layout .app-content');
		if(miniLayout !== null){
			miniLayout.scrollTop = 0;
		}
	}, 200);
})



Vue.filter('currency', formatCurrency('USD'))

// plugins
Vue.use(Vuetify, {
	theme: primaryTheme
})

// Vue.use(InstantSearch);
Vue.use(VueI18n)
Vue.use(AmCharts)
Vue.use(AmSerial)
Vue.use(VueTour)
// Vue.use(AmAngularGauge)
// Vue.use(Vue2Dragula)
Vue.use(VueQuillEditor)
Vue.use(VueResource)
Vue.use(wysiwyg, {})
Vue.use(VueBreadcrumbs)
Vue.use(Notifications, { velocity })
Vue.use(fullscreen);
Vue.use(GlobalComponents);
//Vue.use(VueVideoPlayer);
// Vue.use(Croppa);
Vue.use(auth)
// Vue.use(VueGoogleMaps, {
// 	load: {
// 		key: 'AIzaSyBtdO5k6CRntAMJCF-H5uZjTCoSGX95cdk' // Add your here your google map api key
// 	}
// })

// Create VueI18n instance with options
const i18n = new VueI18n({
	locale: store.getters.selectedLocale.locale, // set locale
	messages, // set locale messages
})

/* eslint-disable no-new */


router.beforeEach((to, from, next) => {
	const auth = store.state.auth
	const user = auth.user

	// if (checkBlockedBrowsers()) {
	// 	next({
	// 		path: '/login'
	// 	})
	// }

	// no log in page for logged in users
	const isLoggedIn = !!auth.accessToken

	// already logged in users will be forwarded to the dashboard
	if (to.name === 'auth.login' && isLoggedIn) {
		next({ path: '/dashboard' })
	}
	// check authentication
	if (to.meta.requiresAuth) {
		// not logged in - redirect to login page
		if (!isLoggedIn) {
			next({
				path: '/auth/login',
				query: { redirect: to.fullPath }
			})
		} else if (to.meta.adminRole) {
			// user is not in admin role. redirect him to dashboard.
			if (!user.isAdmin) {
				next({
					path: '/dashboard'
				})
			} else {
				// everything is ok!
				next()
			}
		} else {
			// everything is ok!
			next()
		}
	} else {
		next() // make sure to always call next()!
	}
})

Vue.use(new VueSocketIO({
   debug: !!c.debug,
   connection: c.rootUrl, //'http://metinseylan.com:1992',
   vuex: {
	  store,
	  actionPrefix: 'SOCKET_',
	  mutationPrefix: 'SOCKET_'
   }
}))

new Vue({
	store,
	i18n,
	router,
	render: h => h(App),
	components: { App },
	// beforeCreate() {
	// 	this.$store.commit('initialiseStore')
	// }
}).$mount('#app')
